import React, {useEffect, useState} from "react";
import {useSelect} from "downshift";
import {axiosInstance} from "../../../../config/http";
import {get} from "lodash";
import {Button} from "../../../../common/styled";
import {toast} from "react-toastify";

export default function UploadData() {
   const [file, setFile] = useState()

  function handleChange(event) {
    setFile(event.target.files[0])
  }

  function handleSubmit(event) {
    event.preventDefault()
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    axiosInstance.put('/upload_file', formData, config).then(response => {
      if (get(response, 'data.msg', '') === 'success') {
        toast.success("Uploaded successfully!")
      } else if (get(response, 'data.error')) {
        toast.error("Failed! " + get(response, 'data.error'))
      } else {
        toast.error("Failed! Please contact the dev team.")
      }
    }).catch(error => {
      console.error(error)
      toast.error("Failed! Please contact the dev team.")
    })
  }

  return (
    <div className="Pairwise Comparison Upload">
        <form onSubmit={handleSubmit}>
          <h2>File Upload to Pairwise Comparison Table</h2>
          <h4>Only upload files of type <b>.csv</b>, with the following columns in the following order: <br /> 
          <span style={{ color: '#2a7ae2'}}>usecase, comparison_object, rank, source, and region (optional)</span>
          </h4>
          <input type="file" onChange={handleChange}/>
          <button type="submit">Upload</button>
        </form>
    </div>
  );
}
